import { Component } from '@angular/core';
import { BaseButtonComponent } from '../base-button/base-button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-secondary-button',
  templateUrl: '../base-button/base-button.component.html',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['../base-button/base-button.component.scss', './secondary-button.component.scss']
})
export class SecondaryButtonComponent extends BaseButtonComponent {}
